import { __COLORS } from "../../styles/global/__colors";
import { css } from "../../utils/barrels/emotion-react";
import { styled } from "../../utils/barrels/emotion-styled";
import { TextField } from "../../utils/barrels/material-ui-core";

export const StyledCustomTextField = styled(({ error, ...props }) => (
	<TextField error={error} {...props} />
))`
	&& {
		width: 100%;

		.MuiInputBase-root {
			font-size: unset;
		}

		.MuiOutlinedInput-root {
			border-radius: 6px;
		}

		.MuiInputLabel-outlined {
			font-weight: 500;
			font-family: Inter, sans-serif;
			font-size: 14px;
			color: ${__COLORS.mediumGrey} !important;
			top: -6px;
		}

		.MuiInputLabel-outlined[data-shrink="true"] {
			top: 0;
		}

		.MuiOutlinedInput-input {
			padding: 12px;
			font-weight: 500;
			font-size: 14px;

			@media screen and (-webkit-min-device-pixel-ratio: 0) {
				font-size: 16px;
			}

			@media only screen and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
				font-size: 16px;
			}
		}

		.MuiOutlinedInput-notchedOutline {
			border: 1px solid ${__COLORS.mediumGrey};
		}

		.Mui-focused .MuiOutlinedInput-notchedOutline {
			border: 1px solid ${__COLORS.vividPurple};
		}

		.MuiOutlinedInput-input.Mui-disabled {
			border-radius: 8px;
			background-color: ${__COLORS.whiteSmoke};
			color: ${__COLORS.softGrey} !important;
		}

		.MuiInputBase-input.Mui-disabled {
			color: ${__COLORS.softGrey} !important;
		}

		.MuiFormLabel-root.Mui-disabled {
			color: ${__COLORS.softGrey} !important;
		}

		.MuiInputLabel-outlined.Mui-disabled {
			color: ${__COLORS.softGrey} !important;
		}

		.MuiInputLabel-standard {
			font-weight: 500;
			font-family: Inter, sans-serif;
			font-size: 14px;
			color: ${__COLORS.mediumGrey};
		}

		.MuiInputLabel-standard.Mui-disabled {
			color: ${__COLORS.softGrey} !important;
		}

		.MuiInputBase-root.Mui-disabled::before {
			border-bottom-style: dotted !important;
			border-bottom-color: ${__COLORS.mediumGrey} !important;
		}

		.MuiInput-underline.Mui-disabled::before {
			border-bottom-style: dotted !important;
			border-bottom-color: ${__COLORS.mediumGrey} !important;
		}

		${({ error }) =>
			error &&
			css`
				.MuiOutlinedInput-notchedOutline {
					border: 1px solid ${__COLORS.crimsonRed} !important;
				}
				.MuiInputLabel-outlined {
					color: ${__COLORS.crimsonRed} !important;
				}
			`}
	}
`;
